// class CartDrawer extends HTMLElement {
//   constructor() {
//     super();
//     this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
//     this.setHeaderCartIconAccessibility();
//     this._boundHandleDocumentKeyDown = this._handleDocumentKeyDown.bind(this);
//     this._injectCartDrawerFixStyles();
//   }

//   _injectCartDrawerFixStyles() {
//     if (document.getElementById('cart-drawer-fix-styles')) return;

//     const style = document.createElement('style');
//     style.id = 'cart-drawer-fix-styles';
//     style.textContent = `
//       cart-drawer:not(.is-empty) .drawer__inner-empty {
//         display: none !important;
//       }
//       cart-drawer .cart-item__error:has(.cart-item__error-text:empty),
//       cart-drawer .cart-item__error .cart-item__error-text:empty + svg {
//         display: none !important;
//       }
//       cart-drawer .cart-item__media .responsive-image {
//         width: 9rem;
//         max-width: 9rem;
//         flex-shrink: 0;
//       }
//       cart-drawer .cart-item__media .responsive-image img {
//         opacity: 1 !important;
//       }
//       cart-drawer .cart-item__media .responsive-image:not(:has(.img-loaded)) {
//         background: #111;
//       }
//     `;
//     document.head.appendChild(style);
//   }

//   _fixCartDrawerUi() {
//     if (!this.classList.contains('is-empty')) {
//       const emptyState = this.querySelector('.drawer__inner-empty');
//       if (emptyState) emptyState.style.display = 'none';
//     }

//     this.querySelectorAll('.cart-item__error').forEach((errorEl) => {
//       const textEl = errorEl.querySelector('.cart-item__error-text');
//       if (!textEl || !textEl.textContent.trim()) {
//         errorEl.style.display = 'none';
//       }
//     });

//     this.querySelectorAll('responsive-image img').forEach((img) => {
//       const wrapper = img.closest('responsive-image');

//       if (wrapper && wrapper.originalSrcset && !img.getAttribute('srcset')) {
//         img.setAttribute('srcset', wrapper.originalSrcset);
//       }

//       img.loading = 'eager';

//       const markLoaded = () => {
//         img.classList.add('img-loaded');
//         img.classList.remove('img-loading');
//       };

//       if (img.complete) {
//         markLoaded();
//       } else {
//         img.addEventListener('load', markLoaded, { once: true });
//         img.addEventListener('error', markLoaded, { once: true });
//       }
//     });
//   }

//   setHeaderCartIconAccessibility() {
//     const cartLink = document.querySelector('#cart-icon-bubble');
//     if (!cartLink) return;

//     cartLink.setAttribute('role', 'button');
//     cartLink.setAttribute('aria-haspopup', 'dialog');
//     cartLink.addEventListener('click', (event) => {
//       event.preventDefault();
//       this.open(cartLink);
//     });
//     cartLink.addEventListener('keydown', (event) => {
//       if (event.code.toUpperCase() === 'SPACE') {
//         event.preventDefault();
//         this.open(cartLink);
//       }
//     });
//   }

//   open(triggeredBy) {
//     if (triggeredBy) this.setActiveElement(triggeredBy);

//     const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
//     if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) {
//       this.setSummaryAccessibility(cartDrawerNote);
//     }

//     this._fixCartDrawerUi();

//     setTimeout(() => {
//       this.classList.add('animate', 'active');
//       this._fixCartDrawerUi();
//     }, 30);

//     this.addEventListener(
//       'transitionend',
//       () => {
//         this._fixCartDrawerUi();
//         const containerToTrapFocusOn = this.classList.contains('is-empty')
//           ? this.querySelector('.drawer__inner-empty')
//           : document.getElementById('CartDrawer');
//         const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
//         if (typeof trapFocus === 'function') {
//           trapFocus(containerToTrapFocusOn, focusElement);
//         }
//       },
//       { once: true }
//     );

//     document.body.classList.add('overflow-hidden');
//     document.addEventListener('keydown', this._boundHandleDocumentKeyDown);
//   }

//   close() {
//     if (!this.classList.contains('active')) return;

//     this.classList.remove('active');

//     if (typeof removeTrapFocus === 'function' && this.activeElement) {
//       removeTrapFocus(this.activeElement);
//     }

//     document.body.classList.remove('overflow-hidden');
//     document.removeEventListener('keydown', this._boundHandleDocumentKeyDown);
//   }

//   _handleDocumentKeyDown(event) {
//     if (event.code === 'Escape' && this.classList.contains('active')) {
//       if (document.querySelector('modal-drawer[open]')) return;
//       event.preventDefault();
//       this.close();
//     }
//   }

//   setSummaryAccessibility(cartDrawerNote) {
//     cartDrawerNote.setAttribute('role', 'button');
//     cartDrawerNote.setAttribute('aria-expanded', 'false');

//     if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
//       cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
//     }

//     cartDrawerNote.addEventListener('click', (event) => {
//       event.currentTarget.setAttribute(
//         'aria-expanded',
//         !event.currentTarget.closest('details').hasAttribute('open')
//       );
//     });

//     if (typeof onKeyUpEscape === 'function') {
//       cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
//     }
//   }

//   renderContents(parsedState) {
//     const drawerInner = this.querySelector('.drawer__inner');
//     if (drawerInner && drawerInner.classList.contains('is-empty')) {
//       drawerInner.classList.remove('is-empty');
//     }

//     this.productId = parsedState.id;

//     this.getSectionsToRender().forEach((section) => {
//       const sectionElement = section.selector
//         ? document.querySelector(section.selector)
//         : document.getElementById(section.id);

//       if (sectionElement) {
//         sectionElement.innerHTML = this.getSectionInnerHTML(
//           parsedState.sections[section.id],
//           section.selector
//         );
//       }
//     });

//     this._fixCartDrawerUi();

//     setTimeout(() => {
//       const overlay = this.querySelector('#CartDrawer-Overlay');
//       if (overlay) {
//         overlay.removeEventListener('click', this.close.bind(this));
//         overlay.addEventListener('click', this.close.bind(this));
//       }
//       this.open();
//     }, 50);
//   }

//   getSectionInnerHTML(html, selector = '.shopify-section') {
//     return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
//   }

//   getSectionsToRender() {
//     return [
//       { id: 'cart-drawer', selector: '#CartDrawer' },
//       { id: 'cart-icon-bubble' },
//     ];
//   }

//   getSectionDOM(html, selector = '.shopify-section') {
//     return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
//   }

//   setActiveElement(element) {
//     this.activeElement = element;
//   }
// }

// customElements.define('cart-drawer', CartDrawer);

// class CartDrawerItems extends CartItems {
//   getSectionsToRender() {
//     return [
//       { id: 'CartDrawer', section: 'cart-drawer', selector: '.drawer__inner' },
//       { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' },
//     ];
//   }
// }

// customElements.define('cart-drawer-items', CartDrawerItems);



class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
    this._boundHandleDocumentKeyDown = this._handleDocumentKeyDown.bind(this);
    this._injectCartDrawerFixStyles();
  }

  _injectCartDrawerFixStyles() {
    if (document.getElementById('cart-drawer-fix-styles')) return;

    const style = document.createElement('style');
    style.id = 'cart-drawer-fix-styles';
    style.textContent = `
      cart-drawer:not(.is-empty) .drawer__inner-empty {
        display: none !important;
      }
      cart-drawer .cart-item__error:has(.cart-item__error-text:empty),
      cart-drawer .cart-item__error .cart-item__error-text:empty + svg {
        display: none !important;
      }
      cart-drawer .cart-item__media .responsive-image {
        width: 9rem;
        max-width: 9rem;
        flex-shrink: 0;
      }
      cart-drawer .cart-item__media .responsive-image img {
        opacity: 1 !important;
      }
    `;
    document.head.appendChild(style);
  }

  _fixCartDrawerUi() {
    if (!this.classList.contains('is-empty')) {
      const emptyState = this.querySelector('.drawer__inner-empty');
      if (emptyState) emptyState.style.display = 'none';
    }

    this.querySelectorAll('.cart-item__error').forEach((errorEl) => {
      const textEl = errorEl.querySelector('.cart-item__error-text');
      if (!textEl || !textEl.textContent.trim()) {
        errorEl.style.display = 'none';
      }
    });

    this.querySelectorAll('responsive-image img').forEach((img) => {
      const wrapper = img.closest('responsive-image');

      if (wrapper && wrapper.originalSrcset && !img.getAttribute('srcset')) {
        img.setAttribute('srcset', wrapper.originalSrcset);
      }

      img.loading = 'eager';

      const markLoaded = () => {
        img.classList.add('img-loaded');
        img.classList.remove('img-loading');
      };

      if (img.complete) {
        markLoaded();
      } else {
        img.addEventListener('load', markLoaded, { once: true });
        img.addEventListener('error', markLoaded, { once: true });
      }
    });
  }

  _lockPageScroll() {
    if (this._scrollLocked) return;
    this._scrollLocked = true;
    this._scrollY = window.scrollY || window.pageYOffset || 0;
    document.documentElement.classList.add('cart-drawer-open');
    document.body.classList.add('overflow-hidden', 'cart-drawer-open');
    document.body.style.position = 'fixed';
    document.body.style.top = `-${this._scrollY}px`;
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
  }

  _unlockPageScroll() {
    if (!this._scrollLocked) return;
    this._scrollLocked = false;
    document.documentElement.classList.remove('cart-drawer-open');
    document.body.classList.remove('overflow-hidden', 'cart-drawer-open');
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    window.scrollTo(0, this._scrollY || 0);
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);

    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) {
      this.setSummaryAccessibility(cartDrawerNote);
    }

    this._fixCartDrawerUi();
    this.classList.add('animate');

    const drawerInner = this.querySelector('.drawer__inner');
    const startOpen = () => {
      this.classList.add('active');
      this._fixCartDrawerUi();
    };

    if (!this.classList.contains('active')) {
      requestAnimationFrame(() => {
        requestAnimationFrame(startOpen);
      });
    } else {
      startOpen();
    }

    const onOpenTransitionEnd = (event) => {
      if (drawerInner && event.target !== drawerInner) return;

      this._fixCartDrawerUi();
      const containerToTrapFocusOn = this.classList.contains('is-empty')
        ? this.querySelector('.drawer__inner-empty')
        : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      if (typeof trapFocus === 'function') {
        trapFocus(containerToTrapFocusOn, focusElement);
      }
    };

    if (drawerInner) {
      drawerInner.addEventListener('transitionend', onOpenTransitionEnd, { once: true });
    } else {
      onOpenTransitionEnd({ target: null });
    }

    document.body.classList.add('overflow-hidden');
    this._lockPageScroll();
    document.addEventListener('keydown', this._boundHandleDocumentKeyDown);
  }

  close() {
    if (!this.classList.contains('active')) return;

    this.classList.remove('active');

    const drawerInner = this.querySelector('.drawer__inner');
    let finished = false;
    const finishClose = () => {
      if (finished) return;
      finished = true;
      this.classList.remove('animate');
      this._unlockPageScroll();
    };

    if (drawerInner) {
      drawerInner.addEventListener(
        'transitionend',
        (event) => {
          if (event.target !== drawerInner) return;
          finishClose();
        },
        { once: true }
      );
      setTimeout(finishClose, 450);
    } else {
      finishClose();
    }

    if (typeof removeTrapFocus === 'function' && this.activeElement) {
      removeTrapFocus(this.activeElement);
    }

    document.removeEventListener('keydown', this._boundHandleDocumentKeyDown);
  }

  _handleDocumentKeyDown(event) {
    if (event.code === 'Escape' && this.classList.contains('active')) {
      if (document.querySelector('modal-drawer[open]')) return;
      event.preventDefault();
      this.close();
    }
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute(
        'aria-expanded',
        !event.currentTarget.closest('details').hasAttribute('open')
      );
    });

    if (typeof onKeyUpEscape === 'function') {
      cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
    }
  }

  renderContents(parsedState) {
    const drawerInner = this.querySelector('.drawer__inner');
    if (drawerInner && drawerInner.classList.contains('is-empty')) {
      drawerInner.classList.remove('is-empty');
    }

    const itemCount =
      parsedState.item_count != null
        ? parsedState.item_count
        : parsedState.items?.reduce((sum, item) => sum + (item.quantity || 0), 0);

    if (itemCount != null) {
      this.classList.toggle('is-empty', itemCount === 0);
    } else {
      this.classList.remove('is-empty');
    }

    this.productId = parsedState.id;

    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (sectionElement) {
        sectionElement.innerHTML = this.getSectionInnerHTML(
          parsedState.sections[section.id],
          section.selector
        );
      }
    });

    const drawerItems = this.querySelector('cart-drawer-items');
    if (drawerItems) {
      const hasItems =
        itemCount != null ? itemCount > 0 : !!this.querySelector('.cart-item');
      drawerItems.classList.toggle('is-empty', !hasItems);
    }

    this._fixCartDrawerUi();

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        const overlay = this.querySelector('#CartDrawer-Overlay');
        if (overlay) {
          overlay.removeEventListener('click', this.close.bind(this));
          overlay.addEventListener('click', this.close.bind(this));
        }
        this.open();
      });
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      { id: 'cart-drawer', selector: '#CartDrawer' },
      { id: 'cart-icon-bubble' },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      { id: 'CartDrawer', section: 'cart-drawer', selector: '.drawer__inner' },
      { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
